module.exports = __webpack_public_path__ + "img/no.b884cec9.svg";